import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface RoofingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Roofing: React.FC<RoofingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [roofing, set_roofing] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Exterior Finishes']?.['Roofing'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Finishes': { ...b.values?.['Exterior Finishes'], 'Roofing': v } } })
    );
    const label = 'Roofing';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(roofing)}
                />
            ) : (
                <MoneyBox
                    id={'roofing'}
                    allowNegative={false}
                    value={roofing}
                    onChange={(value) => set_roofing(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
